/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
// import * as types from '@/lib/definition/types'
import Param from '@/lib/definition/variables'

const KEY_LOGINUSER = 'LOGINUSER'
export interface LoginState {
  errorMessage: string|null
  accessToken: string|null
  username: string|null
  displayName: string|null
  currentRoles: Array<string>
  loginUser: string|null
  email: string|null
  userInfo: any|null
  displayedSlackAuth: boolean
  [key: string]: any
}

const login = defineModule({
  state: (): LoginState => {
    return {
      errorMessage: null,
      accessToken: Lib.Session.value(),
      username: null,
      displayName: null,
      currentRoles: [],
      loginUser: null,
      email: null,
      userInfo: null,
      displayedSlackAuth: false
    }
  },
  getters: {
    loggedIn: (...args): boolean => {
      const { state } = loginGetterContext(args)
      return state.accessToken !== null
    },
    isAdmin: (...args): boolean => {
      const { state } = loginGetterContext(args)
      return state.currentRoles.includes('Admin')
    },
    email: (...args): string|null => {
      const { state } = loginGetterContext(args)
      return state.email
    },
    displayName: (...args): string|null => { 
      const { state } = loginGetterContext(args)
      if (state.userInfo == null) return state.displayName
      var additional = ''
      if (state.userInfo.hasSubUser == true) {
        additional = '[メイン]'
      }
      if (state.userInfo.supplimentalName != null) {
        additional = '[' + state.userInfo.supplimentalName + ']'
      }
      return state.displayName + additional
    },
    additional: (...args): string|null => { 
      const { state } = loginGetterContext(args)
      if (state.userInfo == null) return ''
      var additional = ''
      if (state.userInfo.hasSubUser == true) {
        additional = '[メイン]'
      }
      if (state.userInfo.supplimentalName != null) {
        additional = '[' + state.userInfo.supplimentalName + ']'
      }
      return additional
    },
    ignoreTimesheet: (...args): boolean => { 
      const { state } = loginGetterContext(args)
      if (state.userInfo == null) return true
      return state.userInfo.ignoreTimesheet
    },
    slackAuthorizeNeeded: (...args): boolean => {
      const { state } = loginGetterContext(args)
      if (state.userInfo == null) { return false }
      if (state.userInfo.skipSlackAuth) { return false }
      return (state.userInfo.slackId != null) && (state.userInfo.slackUserTokenIssued == null || state.userInfo.slackUserTokenIssued == "")
    },
    slackAuthorizedDialogShouldOpen: (...args): boolean => {
      const { state } = loginGetterContext(args)
      if (state.userInfo == null) { return false }
      if (state.userInfo.skipSlackAuth) { return false }
      return (state.userInfo.slackId != null) && (state.userInfo.slackUserTokenIssued == null || state.userInfo.slackUserTokenIssued == "") && state.displayedSlackAuth == false
    },
    hasLeadingProject: (...args): boolean => {
      const { state } = loginGetterContext(args)
      if (state.userInfo == null) { return false }
      return state.userInfo.hasLeadingProject
    }
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    },
    SET_ACCESS_TOKEN (state, token: string) {
      state.accessToken = token
      state.errorMessage = null
      Lib.Session.login(token)
    },
    LOGOUT (state) {
      state.accessToken = null
      state.username = null
      state.displayName = null
      state.currentRoles = []
      Lib.Session.remove(KEY_LOGINUSER)
      Lib.Session.logout()
    },
    SET_USERNAME (state, name) {
      state.username = name
    },
    SET_EMAIL (state, email) {
      state.email = email
    },
    SET_DISPLAYNAME (state, name) {
      state.displayName = name
    },
    SET_LOGINUSER (state, lu) {
      if (lu != null) {
        Lib.Session.valueSet(KEY_LOGINUSER, lu)
      }else{
        Lib.Session.remove(KEY_LOGINUSER)
      }
    },
    SET_CURRENT_ROLES (state, cr) {
      state.currentRoles = cr
    },
    SET_LOGIN_ERROR_MESSAGE (state, message) {
      state.errorMessage = message
    },
    SET_USER_INFO (state, userinfo) {
      state.userInfo = userinfo
    },

    SET_DISPLAYED_SLACK_AUTH (state) {
      state.displayedSlackAuth = true
    }
  },
  actions: {
    async login (context, {email, password, tenantId}): Promise<any> {
      const { commit, dispatch } = moduleActionContext(context, login)
      if (Param.Site.useWinAuth) {
        await dispatch.getUserInfo()
      } else {
        var param = {
          TenantId: tenantId,
          Email: email,
          Password: password
        }
        const result = await Lib.Ajax.postHandleError<any>('/api/auth/login','ログインに失敗しました。メールアドレスとパスワードをご確認ください。', param)
        commit.SET_ACCESS_TOKEN(result.data.data.token)
        commit.SET_USERNAME(result.data.data.username)
        return
      }
    },
    async getUserInfo (context): Promise<any> {
      const { commit, state } = moduleActionContext(context, login)
      try {
        const result = await Lib.Ajax.getHandleError<any>('/api/auth/userinfo', 'ユーザー情報の取得に失敗しました',{}, state.accessToken)
        commit.SET_USER_INFO(result.data.data);
        commit.SET_EMAIL(result.data.data.email)
        commit.SET_CURRENT_ROLES(result.data.data.roles)
        commit.SET_DISPLAYNAME(result.data.data.displayName)
        return true
      } catch {
        commit.LOGOUT()
        var location: any = '/#/loginview'
        document.location = location
        return false    
      }
    },
    async openSlackAuthDialog (context) {
      const { commit } = moduleActionContext(context, login)
      commit.SET_DISPLAYED_SLACK_AUTH()
    },
    async openSlackAuth (context) {
      const {state} = moduleActionContext(context, login)
      var location: any = 'https://slack.com/oauth/v2/authorize?client_id=' + state.userInfo.clientId + '&user_scope=chat:write,channels:read,channels:history,im:read,im:write,groups:read,groups:write&state=' + state.userInfo.tenantId
      document.location = location
    },
    async loginWithEntraToken (context, { tenantId, idToken }): Promise<any> {
      const { commit } = moduleActionContext(context, login)
      const param = { TenantId: tenantId, IdToken: idToken }
      const result = await Lib.Ajax.postJsonHandleError<any>('/api/auth/entra-login', 'Entra IDログインに失敗しました。Koosに登録されたユーザーかご確認ください。', param)
      commit.SET_ACCESS_TOKEN(result.data.data.token)
      commit.SET_USERNAME(result.data.data.username)
    },
    async skipSlackAuth (context): Promise<any> {
      const { state, dispatch } = moduleActionContext(context, login)
      await Lib.Ajax.getHandleError<any>('/api/user/skipslackauth', 'Slack認証スキップに失敗しました', {}, state.accessToken)
      await dispatch.getUserInfo()
    }
  },
  namespaced: true
})
export default login
const loginGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, login)
